<template>
  <div>
    <div class="loader" v-if="this.isLoading"></div>   
    <div class="loadertext" v-if="this.isLoading"> {{$t('loadingTxt')}}...</div>   
    <div class="main-wrapper" :class="{'blur-content': this.isLoading}">

        <!--begin::navbar-->
        <navbar-component></navbar-component>
        <!--end::navbar-->

      <div class="page-wrapper">

        <!--begin::content-->
        <div class="page-content">
          <div class="row">
            <div class="col-lg-12 col-xl-12 col-sm-12 col-xs-12 col-md-12">
              <div class="card">
                <div class="card-header">
                  <!-- <i class="link-icon float-start" data-feather="arrow-left"></i> -->
                  &nbsp;&nbsp;&nbsp;
                  <h6 class="card-title mb-0 float-start" style="padding-left: 25px">
                    {{ $t("edit_rate_header_txt") }}
                  </h6>
                   
                </div>

                <div class="card-body">
                 
                  <form
                    class="forms-sample"
                    @submit.prevent="submitData"
                    method="POST"
                  >
              
                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">{{
                          $t('customerGroup')
                        }}</label>
                      </div>
                      <div class="col-lg-8">
                        <input
                          type="text"
                          class="form-control"
                          id="customerGroup"
                          :placeholder="$t('customerGroup')"
                          v-model="forms.customerGroup"
                          required
                        />
                        <div v-if="errors.customerGroup">
                          <div
                            v-for="error in errors.customerGroup"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label for="customerSAPCode" class="col-form-label" style="padding-left: 25px">{{
                          $t('customerSAPCode')
                        }}</label>
                      </div>
                      <div class="col-lg-8">
                        <input
                          type="text"
                          class="form-control"
                          id="customerSAPCode"
                          :placeholder="$t('customerSAPCode')"
                          v-model="forms.customerSAPCode"
                          required
                        />
                        <div v-if="errors.customerSAPCode">
                          <div
                            v-for="error in errors.customerSAPCode"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>

                    
                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label for="customerId" class="col-form-label" style="padding-left: 25px">{{
                          $t('customerId')
                        }}</label>
                      </div>
                      <div class="col-lg-8">
                        
                        <v-select
                            :options="fetchCustomer"
                            v-model="customer"
                            label="customerId"
                            return-object
                            @search="asyncSearchCustomer"
                          ></v-select>



                        <div v-if="errors.customerId">
                          <div
                            v-for="error in errors.customerId"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>


                    
                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label for="warehouseId" class="col-form-label" style="padding-left: 25px">{{
                          $t('warehouseId_txt')
                        }}</label>
                      </div>
                      <div class="col-lg-8">
                        
                        <v-select
                            :options="fetchFulfillment"
                            v-model="fulfillment"
                            label="warehouseId"
                            return-object
                            @search="asyncSearchFulfillment"
                          >
                          <template v-slot:item="{ item, index }">
                            <v-chip text-color="white" :color="item.color" :key="index" small>{{ item.warehouseId }}</v-chip>
                          </template>
                        </v-select>



                        <div v-if="errors.warehouseId">
                          <div
                            v-for="error in errors.warehouseId"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>


                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">{{
                          $t('rateName_txt')
                        }}</label>
                      </div>
                      <div class="col-lg-8">
                        <input
                          type="text"
                          class="form-control"
                          id="rateName"
                          :placeholder="$t('rateName_txt')"
                          v-model="forms.rateName"
                          required
                        />
                        <div v-if="errors.rateName">
                          <div
                            v-for="error in errors.rateName"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>


                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">{{
                          $t('effectiveDate_txt')
                        }}</label>
                      </div>
                      <div class="col-lg-8">

                        <date-range-picker style="width:100%" @update="fromDatesChange" control-container-class="form-control" :locale-data="locale" v-model="fromDates" :opens="opens" :singleDatePicker="false" :timePicker24Hour="false" :timePicker="false" :showWeekNumbers="false"></date-range-picker>

                        <div v-if="errors.effectiveFromDate">
                          <div
                            v-for="error in errors.effectiveFromDate"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>

                      </div>
                    </div>


                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">{{
                          $t('firstBilingDate_txt')
                        }}</label>
                      </div>
                      <div class="col-lg-8">

                        <date-range-picker style="width:100%" @update="firstDatesChange" control-container-class="form-control" :locale-data="locale" v-model="endDates" :opens="opens" :singleDatePicker="true" :timePicker24Hour="false" :timePicker="false" :showWeekNumbers="false"></date-range-picker>

                        <div v-if="errors.firstBilingDate">
                          <div
                            v-for="error in errors.firstBilingDate"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>

                      </div>
                    </div>



                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label for="status" class="col-form-label" style="padding-left: 25px">{{
                          $t('statusTxt')
                        }}</label>
                      </div>
                      <div class="col-lg-8">
                        
                        <v-select
                            :options="fetchStatus"
                            v-model="forms.status"
                            return-object
                          ></v-select>
                        <div v-if="errors.status">
                          <div
                            v-for="error in errors.status"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>



                    <div class="card-footer">
                      <button
                        class="
                          btn btn-warning
                          text-black
                          fw-bolder
                          btn-icon-text
                        "
                        @click="backForm"
                        type="button"
                      >
                        <i class="link-icon" data-feather="arrow-left"></i>
                        {{ $t("backMess") }}
                      </button>
                      &nbsp;&nbsp;&nbsp;
                      <button class="btn btn-primary float-end btn-sm" type="submit">
                           <i class="link-icon" data-feather="save"></i>
                        {{ $t("submitFormTxt") }}
                      </button>
                    </div>
                  </form>
                    
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end::content-->

        <!--begin::footer-->
        <footer-component></footer-component>
        <!--end::footer-->
      </div>
    </div>
  </div>
</template>


<script>
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";
import DateRangePicker from 'vue2-daterange-picker';

export default {
  name: "CliRateHeaderEdit",
  props: {},
  components: {
    "navbar-component": navbarComponent,
    "footer-component": footerComponent,
    DateRangePicker,
  },
  data() {

    const startDate = new Date();
    const endDate = new Date();
    endDate.setDate(endDate.getDate() + 24);

    return {
      opens:"center",
      locale:{
        format:"yyyy-mm-dd",
      
      },
      fromDates: {
        startDate: startDate,
        endDate: endDate
      },
      endDates: {
        startDate: startDate,
        endDate: endDate
      },
      highlighted:{

          dates: [ // Highlight an array of dates
            new Date(),
          ],

      },
      disabledAfter:new Date(2019, 10, 6),
      permision_role:[],
      isLoading: false,
      maxToasts: 100,
      position: "up right",
      closeBtn: true,
      errors: [],
      fetchStatus:['ACTIVE','DISABLED'],
      fetchCustomer:[],
      fetchFulfillment:[],
      company_group:"",
      customer:"",
      fulfillment:"",
      userData: "",
      userRole: "",
      companyCode: "",
      forms: { bm_rate_detail: [], idRateHeader: "",rateName:"" , warehouseId:"", customerId:"", customerGroup:"", customerSAPCode:"", firstBilingDate:"", effectiveFromDate:"", effectiveToDate:"", status:"", addwho:"",  editwho:""},
    };
  },
  watch: {},
  methods: {

    fromDatesChange(){

      if(this.fromDates.startDate && this.fromDates.endDate){
        this.forms.effectiveFromDate=this.$moment(String(this.fromDates.startDate)).format('YYYY-MM-DD');
        this.forms.effectiveToDate=this.$moment(String(this.fromDates.endDate)).format('YYYY-MM-DD');
      }
      
    },
    
    firstDatesChange(){
      if(this.endDates.startDate){
        this.forms.firstBilingDate=this.$moment(String(this.endDates.startDate)).format('YYYY-MM-DD');
      }
    },
    
    dateFormat (classes, date) {
      if (!classes.disabled) {
        classes.disabled = date.getTime() < new Date();
      }
      return classes;
    },

    asyncSearchFulfillment(){
 

      const baseURI = this.$settings.endPointBilling + "dashboard/cli-master-warehouse/get-data?download=all";
     
      return this.$http
        .get(
          baseURI,{ timeout: 10000 }
        )
        .then((response) => {
           this.fetchFulfillment=response.data.datas;
        }).catch(error => {

          if(error.code == "ECONNABORTED"){
            this.error("Please Check Your Internet Connection");
          }

        });
    },


    asyncSearchCustomer(){
 
      const baseURI = this.$settings.endPointBilling + "dashboard/cli-master-customer/get-data?download=all";
     
      return this.$http
        .get(
          baseURI,{ timeout: 10000 }
        )
        .then((response) => {
           this.fetchCustomer=response.data.datas;
        }).catch(error => {

          if(error.code == "ECONNABORTED"){
            this.error("Please Check Your Internet Connection");
          }

        });
    },

    
    resetForm() {
    
      this.forms.bm_rate_detail             = [];
      this.forms.idRateHeader               = "";
      this.forms.warehouseId                = "";
      this.forms.customerId                 = "";
      this.forms.customerGroup              = "";
      this.forms.customerSAPCode            = "";
      this.forms.firstBilingDate            = "";
      this.forms.effectiveFromDate          = "";
      this.forms.effectiveToDate            = "";
      this.forms.status                     = "";
      this.forms.addwho                     = "";
      this.forms.editwho                    = "";

    },

    backForm() {
      window.location.href = "/billing-cli-rate";
    },

    loadData(id) {
      this.isLoading = true;
      const baseURI = this.$settings.endPointBilling + "dashboard/cli-rate/detail/" + id;
      return this.$http.get(baseURI,{ timeout: 10000 }).then((response) => {
        
        this.isLoading                    = false;
        this.forms                        = response.data.datas;
        this.endDates.startDate           = this.forms.firstBilingDate;
        this.endDates.endDate             = this.forms.firstBilingDate;
        this.fromDates.startDate          = this.forms.effectiveFromDate;
        this.fromDates.endDate            = this.forms.effectiveToDate;
        this.customer                     = {customerId:this.forms.customerId}
        this.fulfillment                  = {warehouseId:this.forms.warehouseId}

        
      }).catch(error => {
        this.loading();
              
        if(error.code == "ECONNABORTED"){
            this.error(this.$t("check_internet_connection_txt"));
            
        }else{

            if (error.response) {
                if(error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                }else if (error.response.status === 401) {
                    this.logout();
                } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                }else if (error.response.status === 500) {
                    this.$router.push('/server-error');
                }else{
                    this.$router.push('/page-not-found');
                }
            }

        }

        });
    },

    fetchIt() {
      const userDatas     = this.$getUserInfo();
      this.userData       = userDatas.sub;
      this.userRole       = userDatas.sub.role;
      // this.permision_role = userDatas.sub.permision_role;
      let rolePermision = [];
      userDatas.sub.permision_role.forEach(function(permision){
        if(permision.permission.controller == 'RateCliController'){
          rolePermision = permision;
          // console.log(permision);
        }
      });

      if(!rolePermision.method_update){
        this.$router.push("/authorized-error");
      }
      this.permision_role = rolePermision;

    },

    submitData() {
       this.fade(true);
          this.isLoading = true;
          
          
          if(typeof this.customer == "object"){
            this.forms.customerId = this.customer.customerId
          }else{
            this.forms.customerId = ""
          }
            
          if(typeof this.fulfillment == "object"){
            this.forms.warehouseId = this.fulfillment.warehouseId
          }else{
            this.forms.warehouseId = ""
          }
          
          const baseURI =
            this.$settings.endPointBilling + "dashboard/cli-rate/update/" + this.forms.idRateHeader;
          this.$http
            .patch(baseURI, this.forms,{ timeout: 10000 })
            .then((response) => {
              this.loading();
              if (response.data.status === 200) {
                //this.resetForm();
                this.errors = [];
                this.success(response.data.datas.messages);

                //window.history.back();
                var params = this.$onRandom(this.forms.idRateHeader);
                 window.location.href = "/billing-cli-rate/detail/" + params + "?status=200&msg=Successfully";
              } else {
                this.errors = response.data.errors;
                this.resultError(response.data.errors);
              }
            })
            .catch((error) => {
              this.loading();
                this.isLoading = false;
               
        if(error.code == "ECONNABORTED"){
            this.error(this.$t("check_internet_connection_txt"));
            
        }else{

            if (error.response) {
                if(error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                }else if (error.response.status === 401) {
                    this.logout();
                } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                }else if (error.response.status === 500) {
                    this.$router.push('/server-error');
                }else{
                    this.$router.push('/page-not-found');
                }
            }

        }
              //this.resetForm();
            });
    },

      logout(){

          const baseURI = this.$settings.endPoint + "user/logout";
          this.$http.get(baseURI, { timeout: 10000 }).then((response) => {
              
          console.log(response);

          });

          this.$logoutUser();
          window.location.href = '/';
      },

    fade(sType) {
      this.isLoading = sType;
    },

    loading() {
      this.fade(true);
      setTimeout(() => {
        this.fade(false);
      }, 1000); // hide the message after 3 seconds
    },

    resultError(data) {
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          this.error(objectData[y]);
        }
      }
    },

    success(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
        // onShown: function() {
        //     console.log('asdasdasd');
        //     //window.location.href = '/';
        // }
      });

      Toast.fire({
        icon: "success",
        title: kata,
      });
    },

    error(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "error",
        title: kata,
      });
    },
  },
  events: {},
  created: function () {},
  mounted() {
    var params = this.$onBehind(this.$route.params.id);
    this.loadData(params[0]);
    this.fetchIt();
  },
};
</script>
<style scoped>
 
</style>